import { isPostalCodeRequired } from './isPostalCodeRequired';
import { isStateRequired } from './isStateRequired';

type FullAddress = Readonly<{
	address?: string;
	city?: string;
	stateCode?: string;
	countryCode?: string;
	postalCode?: string;
}>;

// oxlint-disable-next-line complexity
export function isAddressComplete(fullAddress: FullAddress | null): boolean {
	if (!fullAddress) return false;

	const { address, city, stateCode, countryCode, postalCode } = fullAddress;

	return !!(
		address?.trim() &&
		city?.trim() &&
		countryCode?.trim() &&
		(stateCode?.trim() || !isStateRequired({ countryCode })) &&
		(postalCode?.trim() || !isPostalCodeRequired({ countryCode }))
	);
}
